<template>
  <div class="container-fluid">
      <div
        class="page-header min-height-100"
      >
        
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">

              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{data.username || "Novo Usuário"}}</h5>
                <p class="mb-0 font-weight-bold text-sm"></p>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >
                  <li class="nav-item">
                    
                      <button
                        class="mb-0 btn bg-gradient-success btn-sm me-2"
                        type="button"
                        name="button"
                        @click="salvarUnico(data)"
                      >
                        Salvar
                      </button>

                  </li>
                  <li class="nav-item">
                      <button
                        class="mb-0 btn btn-outline-danger btn-sm"
                        type="button"
                        name="button"
                        @click="fecharUnico()"
                      >
                        Cancelar
                      </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="mt-4 col-lg-8 mt-lg-0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-sm-6">
                <label>Email</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="data.username"
                />
              </div>
              <div class="col-12 col-sm-6">
                <label>Nível</label>
                <select
                  id="choices-color-edit"
                  class="form-control"
                  name="choices-color"
                  v-model="data.role"
                >
                    <option v-for="m in niveis" :key="m" :value="m">
                      {{ m }}
                    </option>

                </select>
                





              </div>
            </div>
            <div class="row">
              <div class="col-5 col-sm-5">
                <label class="mt-4">Senha <i @click="data.show_p1=true" class="fas fa-eye text-dark opacity-10"></i></label>
                <input class="form-control" :type="data.show_p1?'text':'password'" v-model="data.password" />
              </div>
              <div class="col-5 col-sm-5">
                <label class="mt-4">Confirme a Senha <i @click="data.show_p2=true" class="fas fa-eye text-dark opacity-10"></i></label>
                <input class="form-control" :type="data.show_p2?'text':'password'" v-model="data.password_confirm" />
              </div>
              <div v-if="data.password!=data.password_confirm" class="col-12 col-sm-5">
                  Senhas não são iguais
              </div>

            </div>
            <div class="row">
              <div class="col-sm-6">
                <label class="mt-4" >Operação</label>
                <select
                  id="choices-category"
                  class="form-control"
                  name="choices-category"
                  v-model="data.operacao_id"
                  
                >
                  <option v-for="item in operacoes" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "FormularioUsuarios",
  props: {
      data: {
        type: Object,
        default: () => {
          {};
        },
      },
      niveis: {
        type: Object,
        default: () => {
          {};
        },
      },
      operacoes: {
        type: Object,
        default: () => {
          [];
        },
      },
      salvarUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      fecharUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      }
    },
  mounted() {


  },
  setup(props) {

      const salvarUnico = (veiculo) => {
          props.salvarUnico(veiculo); // Define o novo cen tro do mapa
      };

      const fecharUnico = () => {
          props.fecharUnico(); // Define o novo cen tro do mapa
      };

      // Retorna os métodos ou variáveis que você quer expor
      return {
        salvarUnico,
        fecharUnico
      };
  }
};
</script>
